import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import ModalContext from "../../../../../../../modalZ/context/ModalContext";
import { useCurrentOrganisationId } from "../../../../../../../../services/local/organisationContext/OrganisationContextModel";
import { ProcessLinkModalModel } from "./ProcessLinkModal_model";
import { ProjectProcessesGridModalView } from "../../../../../../../../pages/insight/projects/Processes/ProcessReportingView/modals/ProjectProcessesGridModal/ProjectProcessesGridModal_view";
import { PositionedSpinner } from "@flightpath/coreui/dist/ui/PositionedSpinner";

interface ProcessLinkModalProps {
  projectId: number;
  trainingModuleId: number;
  trainingModule?: FP.Entities.ITrainingModule;
  onAssignSuccess?: any;
}

export const ProcessLinkModal: React.FC<ProcessLinkModalProps> = observer(props => {
  const { projectId, trainingModule, onAssignSuccess } = props;
  const organisationId = useCurrentOrganisationId();
  const [model] = useState(() => new ProcessLinkModalModel(organisationId, projectId, trainingModule));
  useEffect(() => {
    model.onMount();
  }, [model]);

  if (model.isLoading) return <PositionedSpinner></PositionedSpinner>;
  return (
    <ProjectProcessesGridModalView
      onAssignSuccess={items => {
        ModalContext.hide();
        model.assignActionsToTrainingModules(items, onAssignSuccess);
      }}
      selectedItemIds={model.selectedProjectProcessIds}
    />
  );
});
